/**
 * Intervalo entre códigos de SMS na pista (Fase 0, plano 19/10).
 *
 * O servidor recusa um código novo para o mesmo telefone antes de 30 s (429 "Aguarde N
 * segundo(s) para pedir um novo código.") e conta o código desde que ele é gravado, mesmo que o
 * SMS não tenha saído. Por isso o botão Reenviar espera os mesmos 30 s, inclusive depois de um
 * 1º envio que falhou, e acerta a contagem pelo N que o servidor devolve.
 */
export const COOLDOWN_OTP_S = 30;

/** Segundos que faltam, lidos do 429 "Aguarde N segundo(s)..." do servidor; senão null. */
export function segundosDoAguarde(err) {
  if (err?.response?.status !== 429) return null;
  const detalhe = err?.response?.data?.detail;
  const m = /Aguarde\s+(\d+)\s+segundo/i.exec(typeof detalhe === "string" ? detalhe : "");
  if (!m) return null;
  const n = Number(m[1]);
  return Number.isFinite(n) && n > 0 ? Math.min(n, 300) : null;
}
